import { SelectFields } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Enrollment } from '../../lib/types/models/enrollment/enrollment'
import { EnrollmentFilter } from '../../lib/types/models/enrollment/enrollment-filter'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollments<T extends FieldsSelector<Enrollment>>(
  input?: PaginationRequest<EnrollmentFilter>,
  fields?: T
) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.enrollments.getAll.url, null), { ...input, fields })
    )
    .get<PaginationResponse<SelectFields<Enrollment, T>>>()
}
